import { MissingSubAccountRoleDescColumn } from "./columns/MissingSubAccountRoleDescColumn";
import { ProviderAccountNameCell } from "../ProviderAccountNameCell";
import { Account } from "../../../../../../services/cloudchipr.api";
import { ColumnSetupType } from "../../../../../../storybook/data-grid/utils/types/types";

export const getMissingSubAccountsRoleTableColumns =
  (): ColumnSetupType<Account>[] => {
    return columns;
  };

const columns: ColumnSetupType<Account>[] = [
  {
    accessorKey: "provider_account_id",
    cell: ({ row }) => {
      return (
        <ProviderAccountNameCell
          providerId={row.original.provider_account_id}
          providerName={row.original.provider_account_name}
          providerDetails={row.original.provider_details}
        />
      );
    },
  },
  {
    accessorKey: "id",
    cell: ({ row }) => {
      return <MissingSubAccountRoleDescColumn id={row.original.id} />;
    },
  },
];
